/**
 * Created by andrey on 25.11.2025
 */

cleverapps.importProgress = function (fromUserId, options) {
    options = options || {};
    const callback = options.callback || function () {};

    if (connector.SYNC_STATUS.DISABLE === connector.synchronizer.status) {
        callback(cleverapps.CODE_FAILED);
        return;
    }

    const fromSource = options.fromSource;

    let newSession;
    let remoteSnapshot;

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.DEBUG.IMPORT_PROGRESS}start`);

    const loadSnapshot = (f) => {
        const userId = connector.platform.getUserID();

        cleverapps.RestClient.post(
            `/getprogress/${encodeURIComponent(userId)}/${encodeURIComponent(fromUserId)}`,
            { version: cleverapps.config.version },
            (response) => {
                newSession = response.session || response.key;
                remoteSnapshot = response.snapshot || response.sync;
                f();
            },
            (err) => {
                cleverapps.metrics.logEvent(`${cleverapps.EVENTS.DEBUG.IMPORT_PROGRESS}load_failed`);
                console.log("load progress error", err);
                callback("load_failed");
            }
        );
    };

    const isServerBetter = (sUser) => {
        if (sUser.episode !== cleverapps.user.currentPhysicalLevel.episode) {
            return sUser.episode > cleverapps.user.currentPhysicalLevel.episode;
        }
        if (sUser.level !== cleverapps.user.currentPhysicalLevel.level) {
            return sUser.level > cleverapps.user.currentPhysicalLevel.level;
        }
        if (["merge", "merge2", "farm"].includes(cleverapps.config.type) && sUser.exp !== ExpHelper.GetMainInstance().getExp()) {
            return sUser.exp > ExpHelper.GetMainInstance().getExp();
        }
        return false;
    };

    new ActionPlayer([
        loadSnapshot,

        (f) => {
            const users = remoteSnapshot.users;

            let error = "";

            if (!users) {
                error = "empty_users";
            } else if (options.onlyBetter && !isServerBetter(users)) {
                error = "client_better";
            } else if (fromSource && users.source !== fromSource) {
                error = "wrong_source";
            }

            if (error) {
                cleverapps.metrics.logEvent(`${cleverapps.EVENTS.DEBUG.IMPORT_PROGRESS}${error}`);
                callback(cleverapps.CODE_FAILED);
            } else {
                f();
            }
        },

        (f) => {
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.DEBUG.IMPORT_PROGRESS}wants_import`);

            connector.synchronizer.setStatus(connector.SYNC_STATUS.WAIT);

            cleverapps.wantsImportProgress = {
                newSession, remoteSnapshot, callback: f
            };

            console.log(`wants import progress session ${connector.synchronizer.session} -> ${newSession}`);

            cleverapps.placements.run(Placements.SYSTEM_FAULT);
        },

        (f) => {
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.DEBUG.IMPORT_PROGRESS}sync_out`);

            connector.synchronizer.syncOut();
            f();
        }
    ]).play(() => callback(cleverapps.CODE_SUCCEED));
};